import type { ComponentProps } from "react";
import React from "react";

import { cn } from "@/lib/helpers/cn";
import { Button2 } from "@/ui2/atoms/Button";

import { ChevronLeftIcon, ChevronRightIcon } from "../../../../component-library";
import { ICON_SIZES, ICON_TYPES } from "../../../../constants/icons";

type NavigationButtonProps = ComponentProps<typeof Button2> & {
  direction: "left" | "right";
  isDisabled: boolean;
  onClick: VoidFunction;
};

export const NavigationButton = ({
  direction,
  isDisabled,
  onClick,
  ...props
}: NavigationButtonProps) => {
  const Icon = direction === "left" ? ChevronLeftIcon : ChevronRightIcon;

  return (
    <Button2 isDisabled={isDisabled} onPress={onClick} variant="text" {...props}>
      <Icon
        className={cn("tw:fill-fill-teal-primary", isDisabled && "tw:fill-fill-quinary")}
        iconSize={ICON_SIZES.MEDIUM}
        iconType={ICON_TYPES.OUTLINE}
      />
    </Button2>
  );
};
